import { MPA_TRANSACTIONS_CREATE_REQUEST, MPA_TRANSACTIONS_CREATE_SUCCESS, MPA_TRANSACTIONS_CREATE_FAILURE } from './types/ManualPreadviceTransactionsCreateActionsTypes';

export function postManualPreadviceTransactionsCreateRequestActionCreator(context,
  newComments,
  newDepartureDateTime,
  newImpcFrom,
  newImpcTo,
  newOperatorFrom,
  newOperatorTo,
  newPlannedArrivalDateTime,
  newQuantity) {
  return {
    type: MPA_TRANSACTIONS_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newComments,
        departureDateTime: newDepartureDateTime,
        impcFrom: newImpcFrom,
        impcTo: newImpcTo,
        operatorFrom: newOperatorFrom,
        operatorTo: newOperatorTo,
        plannedArrivalDateTime: newPlannedArrivalDateTime,
        quantity: newQuantity,
      },
    },
  };
}

export function postManualPreadviceTransactionsCreateSuccessActionCreator(data) {
  return {
    type: MPA_TRANSACTIONS_CREATE_SUCCESS,
    payload: data,
  };
}

export function postManualPreadviceTransactionsCreateFailureActionCreator(error) {
  return {
    type: MPA_TRANSACTIONS_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
